export interface MockProfile {
  id: string
  role: string
  sector: string
  avatarUrl: string | null
  topicIds: string[]
  matchScore: number
}

export const MOCK_PROFILES: MockProfile[] = [
  // AI Governance heavy
  {
    id: 'p1',
    role: 'Head of AI Policy',
    sector: 'Public sector',
    avatarUrl: null,
    topicIds: ['ai-governance', 'frontier-tech'],
    matchScore: 92,
  },
  {
    id: 'p2',
    role: 'AI Ethics Researcher',
    sector: 'Academia',
    avatarUrl: null,
    topicIds: ['ai-governance', 'skills-mobility'],
    matchScore: 88,
  },
  {
    id: 'p3',
    role: 'Chief Data Officer',
    sector: 'Corporate',
    avatarUrl: null,
    topicIds: ['ai-governance', 'twin-transition'],
    matchScore: 81,
  },
  {
    id: 'p4',
    role: 'Regulatory Affairs Lead',
    sector: 'Consulting',
    avatarUrl: null,
    topicIds: ['ai-governance', 'partnerships'],
    matchScore: 74,
  },
  {
    id: 'p5',
    role: 'AI Product Manager',
    sector: 'Fintech',
    avatarUrl: null,
    topicIds: ['ai-governance', 'innovative-finance'],
    matchScore: 67,
  },
  {
    id: 'p6',
    role: 'ML Engineer',
    sector: 'Agritech',
    avatarUrl: null,
    topicIds: ['ai-governance', 'food-security'],
    matchScore: 58,
  },

  // Climate Adaptation
  {
    id: 'p7',
    role: 'Climate Resilience Director',
    sector: 'NGO',
    avatarUrl: null,
    topicIds: ['climate-adaptation', 'biodiversity'],
    matchScore: 94,
  },
  {
    id: 'p8',
    role: 'Urban Adaptation Planner',
    sector: 'Public sector',
    avatarUrl: null,
    topicIds: ['climate-adaptation', 'partnerships'],
    matchScore: 86,
  },
  {
    id: 'p9',
    role: 'Climate Risk Analyst',
    sector: 'Fintech',
    avatarUrl: null,
    topicIds: ['climate-adaptation', 'innovative-finance'],
    matchScore: 82,
  },
  {
    id: 'p10',
    role: 'Water Systems Engineer',
    sector: 'Consulting',
    avatarUrl: null,
    topicIds: ['climate-adaptation', 'food-security'],
    matchScore: 71,
  },
  {
    id: 'p11',
    role: 'Environmental Scientist',
    sector: 'Academia',
    avatarUrl: null,
    topicIds: ['climate-adaptation', 'biodiversity'],
    matchScore: 63,
  },
  {
    id: 'p12',
    role: 'Resilience Program Manager',
    sector: 'NGO',
    avatarUrl: null,
    topicIds: ['climate-adaptation'],
    matchScore: 52,
  },

  // Food Security
  {
    id: 'p13',
    role: 'Agrifood Innovation Lead',
    sector: 'Agritech',
    avatarUrl: null,
    topicIds: ['food-security', 'regenerative'],
    matchScore: 90,
  },
  {
    id: 'p14',
    role: 'Supply Chain Director',
    sector: 'Corporate',
    avatarUrl: null,
    topicIds: ['food-security', 'twin-transition'],
    matchScore: 83,
  },
  {
    id: 'p15',
    role: 'Food Policy Advisor',
    sector: 'Public sector',
    avatarUrl: null,
    topicIds: ['food-security', 'partnerships'],
    matchScore: 76,
  },
  {
    id: 'p16',
    role: 'Regenerative Ag Founder',
    sector: 'Agritech',
    avatarUrl: null,
    topicIds: ['food-security', 'regenerative', 'biodiversity'],
    matchScore: 69,
  },
  {
    id: 'p17',
    role: 'Nutrition Program Lead',
    sector: 'NGO',
    avatarUrl: null,
    topicIds: ['food-security'],
    matchScore: 55,
  },

  // Biodiversity
  {
    id: 'p18',
    role: 'Conservation Biologist',
    sector: 'Academia',
    avatarUrl: null,
    topicIds: ['biodiversity', 'climate-adaptation'],
    matchScore: 89,
  },
  {
    id: 'p19',
    role: 'Nature-based Solutions Lead',
    sector: 'Consulting',
    avatarUrl: null,
    topicIds: ['biodiversity', 'regenerative'],
    matchScore: 84,
  },
  {
    id: 'p20',
    role: 'Biodiversity Finance Specialist',
    sector: 'Fintech',
    avatarUrl: null,
    topicIds: ['biodiversity', 'innovative-finance'],
    matchScore: 72,
  },
  {
    id: 'p21',
    role: 'Wildlife Program Director',
    sector: 'NGO',
    avatarUrl: null,
    topicIds: ['biodiversity'],
    matchScore: 61,
  },

  // Innovative Finance
  {
    id: 'p22',
    role: 'Impact Investment Partner',
    sector: 'Fintech',
    avatarUrl: null,
    topicIds: ['innovative-finance', 'partnerships'],
    matchScore: 93,
  },
  {
    id: 'p23',
    role: 'Green Bonds Structurer',
    sector: 'Fintech',
    avatarUrl: null,
    topicIds: ['innovative-finance', 'climate-adaptation'],
    matchScore: 85,
  },
  {
    id: 'p24',
    role: 'ESG Fund Manager',
    sector: 'Corporate',
    avatarUrl: null,
    topicIds: ['innovative-finance', 'twin-transition'],
    matchScore: 78,
  },
  {
    id: 'p25',
    role: 'Blended Finance Advisor',
    sector: 'Consulting',
    avatarUrl: null,
    topicIds: ['innovative-finance', 'partnerships'],
    matchScore: 66,
  },

  // Twin Transition + Frontier Tech + Regenerative + Partnerships + Skills
  {
    id: 'p26',
    role: 'Sustainability Director',
    sector: 'Corporate',
    avatarUrl: null,
    topicIds: ['twin-transition', 'partnerships', 'skills-mobility'],
    matchScore: 91,
  },
  {
    id: 'p27',
    role: 'Circular Economy Lead',
    sector: 'Consulting',
    avatarUrl: null,
    topicIds: ['twin-transition', 'regenerative'],
    matchScore: 80,
  },
  {
    id: 'p28',
    role: 'Digital Transformation Head',
    sector: 'Corporate',
    avatarUrl: null,
    topicIds: ['twin-transition', 'frontier-tech'],
    matchScore: 73,
  },
  {
    id: 'p29',
    role: 'Deep Tech Investor',
    sector: 'Fintech',
    avatarUrl: null,
    topicIds: ['frontier-tech', 'innovative-finance'],
    matchScore: 87,
  },
  {
    id: 'p30',
    role: 'Quantum Research Lead',
    sector: 'Academia',
    avatarUrl: null,
    topicIds: ['frontier-tech'],
    matchScore: 75,
  },
  {
    id: 'p31',
    role: 'Robotics Startup CEO',
    sector: 'Agritech',
    avatarUrl: null,
    topicIds: ['frontier-tech', 'food-security'],
    matchScore: 64,
  },
  {
    id: 'p32',
    role: 'Soil Health Scientist',
    sector: 'Academia',
    avatarUrl: null,
    topicIds: ['regenerative', 'biodiversity', 'food-security'],
    matchScore: 86,
  },
  {
    id: 'p33',
    role: 'Regenerative Brand Founder',
    sector: 'Corporate',
    avatarUrl: null,
    topicIds: ['regenerative', 'partnerships'],
    matchScore: 70,
  },
  {
    id: 'p34',
    role: 'Cross-sector Alliances Lead',
    sector: 'NGO',
    avatarUrl: null,
    topicIds: ['partnerships', 'skills-mobility'],
    matchScore: 83,
  },
  {
    id: 'p35',
    role: 'Public-Private Partnerships Head',
    sector: 'Public sector',
    avatarUrl: null,
    topicIds: ['partnerships'],
    matchScore: 68,
  },
  {
    id: 'p36',
    role: 'Future Skills Researcher',
    sector: 'Academia',
    avatarUrl: null,
    topicIds: ['skills-mobility', 'frontier-tech'],
    matchScore: 88,
  },
  {
    id: 'p37',
    role: 'Talent Mobility Director',
    sector: 'Consulting',
    avatarUrl: null,
    topicIds: ['skills-mobility', 'partnerships'],
    matchScore: 77,
  },
  {
    id: 'p38',
    role: 'Green Skills Program Lead',
    sector: 'NGO',
    avatarUrl: null,
    topicIds: ['skills-mobility', 'twin-transition'],
    matchScore: 62,
  },
]
